










































import { Component, Vue, Prop } from 'vue-property-decorator'
import { downloadState } from '../../../store/modules/DownloadState'
import { DownloadLinkInfo } from '../../../modules/class/Downloads'
import Cookie from '../../../modules/util/Cookie'
import { Country } from '../../../modules/class/CountryList'

@Component
export default class CountryRegion extends Vue {
  @Prop() private fileInfo!: DownloadLinkInfo
  private cookie = new Cookie()
  private options: Country[] = []

  // ------------------------------------------------------------------------------------------------
  // hooks
  private async mounted() {
    this.getCountryList()
  }

  // --------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * 国リスト取得
   */
  public async getCountryList(): Promise<void> {
    let options = downloadState.countryList
    if (options.length === 0) {
      await downloadState.fetchCountryList()
      options = downloadState.countryList
    }
    this.options = options
  }

  /**
   * Country/Region選択
   */
  public async selectNation(event: Event): Promise<void> {
    if (event.target instanceof HTMLSelectElement) {
      const target: HTMLSelectElement = event.target
      if (this.fileInfo.invisibleCountry.includes(target.value)) {
        // 非表示国が選択された場合
        this.cookie.setCookie('healthcareReferense', 'ng')
        // 許可しない場合、指定のリンク先へ転送
        window.location.href = this.$t('CountryRegion.redirectLink').toString()
      } else {
        // 表示許可国が選択された場合
        this.cookie.setCookie('healthcareReferense', 'ok')
        this.$emit('select')
      }
    }
  }

  /**
   * 既にCookieを登録済みかを判定
   */
  private hasCookie(): boolean {
    return this.cookie.hasKey('healthcareReferense')
  }

  /**
   * 選択した結果
   * - ok: DLを再開する
    - ng: SSLへ遷移する
   */
  private selected() {
    if (this.cookie.get('healthcareReferense') === 'ok') {
      // DLを再開
      this.$emit('select')
    } else {
      // 許可しない場合、指定のリンク先へ転送
      window.location.href = this.$t('CountryRegion.redirectLink').toString()
    }
  }
}
